<template>
  <div>
    <p>Add auditing configuration to your endpoint setup code:</p>
    <p><code>endpointConfiguration.AuditProcessedMessagesTo("audit");</code></p>
    <p>Make sure the audit queue name matches what your ServiceControl Audit instance is monitoring.</p>
  </div>
</template>
